// src/components/SidebarTabs.jsx
import React, { useState } from "react";
import { CiCalendar } from "react-icons/ci";

/* Utility to read a string or {en, ar} */
const pickLang = (value, lang) => {
  if (!value) return "";
  return typeof value === "object" ? value[lang] : value;
};

const SidebarTabs = ({
  latest = [],
  featured = [],
  language = "en",
  isAdmin,
  onEdit,
  onDelete
}) => {
  const [active, setActive] = useState("latest");
  const list = active === "latest" ? latest : featured;

  return (
    <div className="cards p-3">

      {/* ---------- TABS ---------- */}
      <div className="d-flex align-items-start justify-content-start mb-4">
        <button
          className={`side-act ${active === "latest" ? "act-side" : ""}`}
          onClick={() => setActive("latest")}
        >
          {language === "ar" ? "الأحدث" : "Latest News"}
        </button>

        <button
          className={`side-act ${active === "featured" ? "act-side" : ""}`}
          onClick={() => setActive("featured")}
        >
          {language === "ar" ? "مميزة" : "Featured"}
        </button>
      </div>

      {/* ---------- ITEMS ---------- */}
      {list.map((item) => {
        const title = pickLang(item.title, language);
        const desc = pickLang(item.desc, language);
        const category = pickLang(item.category, language);

        return (
          <div key={item.id} className="latest-feat row">

            {/* IMAGE */}
            <div className="col-4">
              <img
                src={item.img}
                alt={title}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>

            {/* CONTENT */}
            <div className="col-8">
              <span className="side-category">{category}</span>

              <div className="card-title-side">{title}</div>

              <div className="card-desc-side">
                {desc?.length > 140 ? desc.slice(0, 140) + "..." : desc}
              </div>

              <div className="text-muted small mb-1 news-time">
                <CiCalendar className="me-1" /> {item.date}
              </div>

              {/* ---------- ADMIN TOOLS ---------- */}
              {isAdmin && (
                <div className="d-flex gap-2 mt-1">
                  <button
                    className="btn btn-sm btn-warning"
                    onClick={() => onEdit(item)}
                  >
                    {language === "ar" ? "تعديل" : "Edit"}
                  </button>

                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() =>
                      onDelete(
                        item.id,
                        active === "latest" ? "news" : "featured"
                      )
                    }
                  >
                    {language === "ar" ? "حذف" : "Delete"}
                  </button>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SidebarTabs;
